import { AdminApi } from '@guiker/real-estate-shared'
import { TypeOf, yup } from '@guiker/yup-util'

export const updateListingPropertyUnitsSchema = yup.object({
  property: AdminApi.Schema.getCompletePropertyCreationPayloadSchema('$property.building.type'),
})

export type UpdateListingPropertyUnitsSchema = TypeOf<typeof updateListingPropertyUnitsSchema>
